import { NOTI_PERMISSION } from '~/constants';
import { isMainView } from '~/utils/runEnvironmentUtil';

const { Notification } = window;
const NOTI_LIFE_TIME = 5000;

const checkSupports = () => 'Notification' in window;

const getPermission = () => Notification.permission;

const requestPermission = () =>
  getPermission() === NOTI_PERMISSION.GRANTED
    ? Promise.resolve(NOTI_PERMISSION.GRANTED)
    : Notification.requestPermission();

const isGranted = async () => (await requestPermission()) === NOTI_PERMISSION.GRANTED;

const notify = async ({ title, body, onClick }) => {
  if (!isMainView() || !checkSupports()) return;
  await isGranted();
  let timer;
  const onClickWrap = () => {
    onClick();
    noti.close();
    window.clearTimeout(timer);
  };
  const noti = new Notification(title, {
    body,
    icon: '/static_images/error_messenger_bi.png',
    onclick: onClickWrap,
  });
  timer = setTimeout(() => {
    noti.close();
  }, NOTI_LIFE_TIME);
};

const notificationService = {
  notify,
};
export default notificationService;
